module.exports = __webpack_public_path__ + "img/amex-logo.d2d8c1cd.svg";